import { MessageCircle, Phone } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { SITE } from "@/data/site";

export default function FloatingCTA() {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="fixed bottom-5 right-5 z-40 flex flex-col gap-3"
      >
        <a
          href={`tel:${SITE.phoneTel}`}
          aria-label={`Call ${SITE.phoneDisplay}`}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-900 text-white shadow-lift transition-transform hover:scale-105"
          data-testid="floating-call-button"
        >
          <Phone className="h-5 w-5" />
        </a>
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-600 text-white shadow-lift transition-transform hover:scale-105"
          data-testid="floating-whatsapp-button"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
      </motion.div>
    </AnimatePresence>
  );
}
